import { ImprintMethodModel, ProductSpecModel } from '../model'
import { useAddon } from '../store/modules/addon'
import { useApp } from '../store/modules/app'
import { useDropShip } from '../store/modules/dropShip'
import { useImprintMethod } from '../store/modules/imprintMethod'
import { useProductSpec } from '../store/modules/productSpec'
import { useSpec } from '../store/modules/spec'
import {
  type AddonGroup,
  type ArtworkFile,
  type MiniSpecGroup,
  OrderType,
  type PMSColor,
  type SelectedProductSpec,
  type VirtualDesignArt,
  type VirtualDesignFont,
  type VirtualDesignImage,
  type VirtualDesignLogo
} from '../types'
import { useWindow } from './use-window'

type SOInfoProductSpecItemQty = {
  InputQuantity: number
  IsMultiSize: boolean
  SizeQty: any[]
}

type SOInfoProductSpecItemColor = {
  name: string
  selectedText: string
  selectedValue: string
}
type SOInfoProductSpecItem = {
  isApparel: boolean
  productSelectedQty: SOInfoProductSpecItemQty
  selectedSpecList: SOInfoProductSpecItemColor[]
}
type SOInfoSpecItem = {
  name: string
  text: string
  selectedValue: string
}
type SOInfoAddonItem = {
  name: string
  text: string
  selectedValue: string
}

type SOInfoArtworkItem = {
  BoxNetFileSysNo: number
  Extension: string
  FileName: string
  SysNo: number
  ThumbnailUrl: string
  Url: string
}
type SOInfoImprintItem = {
  SysNo: number
  Location: string
  Method: string
  IsPersonalizationSelected: boolean
  SelectedColors: PMSColor[]
  ArtworkOptions: number
  ShareLink: string
  ArtworkFiles: SOInfoArtworkItem[]
  IsVirtualDesign: boolean
  VirtualDesignArts: VirtualDesignArt[]
  VirtualDesignFonts: VirtualDesignFont[]
  VirtualDesignImage: VirtualDesignImage | null
  VirtualDesignJson: string
  CustomerArtworkNotes: string
  VirtualDesignLogo: VirtualDesignLogo[] | null
}

export type SOInfo = {
  OrderType: OrderType
  IsBlank: boolean
  IsFreeGift: boolean
  IsMultiSize: boolean
  ProductSpecSOItems: SOInfoProductSpecItem[]
  SpecSOItems: SOInfoSpecItem[]
  AddonSOItems: SOInfoAddonItem[]
  ImprintSOItems: SOInfoImprintItem[]
  DropShipValue: string
  CouponCode: string
  TransitTime: number
  RushDay: number
  ProductionTime: number
}

export const initOrderInfo = (soInfo: SOInfo) => {
  if (!soInfo) return false

  const {
    productSpecList,
    specList,
    addonList,
    dropShipSetting,
    locationGroupList,
    pmsColorList
  } = useWindow()

  const appState = useApp()
  const productSpecState = useProductSpec()
  const specState = useSpec()
  const addonState = useAddon()
  const imprintMethodState = useImprintMethod()
  const dropShipState = useDropShip()

  appState.setBlankValue(soInfo.IsBlank);

        console.log('aaaaaaaaaa')

  soInfo.ProductSpecSOItems.forEach((item) => {
    const productSpecModel = new ProductSpecModel()

    if (Array.isArray(productSpecModel.quantity)) {
      productSpecModel.quantity.forEach((f) => {
        const findItem = item.productSelectedQty.SizeQty.find(
          (sz: any) => sz.Size === f.size
        )
        if (findItem) {
          f.quantity = parseInt(findItem.Quantity)
        }
      })
    } else {
      productSpecModel.quantity.quantity = item.productSelectedQty.InputQuantity
    }

    // 判断是否为spec sample 或free gift
    if (soInfo.IsFreeGift || soInfo.OrderType == OrderType.SpecSample) {
      // 检查哪个size 有值
      if (Array.isArray(productSpecModel.quantity)) {
        productSpecModel.quantity.forEach(it => {
          if (it.quantity != '') {
            productSpecModel.specSampleSizeType = it.size;
          }
        });
      }
    }

    if (item.selectedSpecList.length > 0) {
      const productSpec = item.selectedSpecList
        .map((f) => {
          const sp = productSpecList.find((sp) => sp.name === f.name)
          const selectedVal =
            sp?.values.find((val) => val.value === f.selectedValue) ??
            sp?.values[0]

          return {
            name: f.name,
            value: selectedVal
          } as SelectedProductSpec
        })
        .filter((f) => f !== undefined);
      if (productSpec) {
        productSpecModel.setProductSpec(productSpec)
      }

    } else if (soInfo.IsFreeGift) {
      // 如果是free gift，那默认选中第一个
      const productSpec = productSpecList.map((sp) => {
        return {
          name: sp.name,
          value: sp.values[0]
        }
      })
      productSpecModel.setProductSpec(productSpec)
    }
    productSpecState.add(productSpecModel)
  })

  soInfo.SpecSOItems.forEach((item) => {
    const obj = specState.getSelectedList.find((k) => k.name === item.name)

    if (obj) {
      //如果有默认选中项，那就用默认选中项。如果没有的话，那只有1个
      if (item.selectedValue) {
        obj.selectedItem = obj.values.find((f) => f.value === item.selectedValue)
      } else if (obj.values.length == 1) {

        obj.selectedItem = obj.values[0]
      }
    } else {
      //如果根据spec name找不到数据，那说明基础数据有问题
      const model: MiniSpecGroup = {
        name: item.name,
        text: item.text,
        selectedItem: specList
          .find((f) => f.name === item.name)
          ?.values.find((f) => f.value === item.selectedValue)
      }
      // specState..push(model)
    }
  })

  soInfo.AddonSOItems.forEach((item: any) => {
    const obj = addonState.getSelectedList.find((k) => k.name === item.name)

    if (obj) {  //如果有默认选中项，那就用默认选中项。如果没有的话，那只有1个
      if (item.selectedValue) {
        const selectedObj = obj.values.find((f) => f.value === item.selectedValue)
        obj.selectedItem  = selectedObj;
      } else if (obj.values.length == 1) {
        obj.selectedItem = obj.values[0]
      }
    }
  })

  soInfo.ImprintSOItems.forEach((item) => {
    const model = new ImprintMethodModel()
    // 先根据location查找数据
    const currentLocation = locationGroupList.find(
      (f) => f.Name === item.Location
    )

    if (currentLocation) {
      const currentMethod = currentLocation.Methods.find(
        (f) => f.Method === item.Method
      )

      if (currentMethod) {
        model.decorationMethod = currentMethod

        model.decorationMethod.selectedArtworkFiles.push(
          ...item.ArtworkFiles.map((f) => {
            return {
              BoxNetFileSysNo: f.BoxNetFileSysNo,
              DownloadUrl: f.Url,
              PreviewUrl: f.Url,
              FileName: f.FileName,
              FileExt: f.Extension,
              ThumbnailUrl: f.ThumbnailUrl
            }
          })
        )
        model.decorationMethod.shareLink = item.ShareLink
        model.decorationMethod.artworkType = item.ArtworkOptions
        model.decorationMethod.customerNotes = item.CustomerArtworkNotes

        model.decorationMethod.isPersonalizationSelected =
          item.IsPersonalizationSelected
        model.decorationMethod.selectedStandardColors =
          currentMethod.DisplayColors.filter((f) =>
            item.SelectedColors.some((s) => s.Name === f.Name)
          )
        model.decorationMethod.selectedPmsColors = pmsColorList.filter((f) =>
          item.SelectedColors.some((s) => s.Name === f.Name)
        )
        model.decorationMethod.selectedColors.push(
          ...model.decorationMethod.selectedStandardColors,
          ...model.decorationMethod.selectedPmsColors
        )
        model.decorationMethod.selectedArtworkFiles = item.ArtworkFiles.map(
          (f) => {
            return {
              BoxNetFileSysNo: f.SysNo,
              ThumbnailUrl: f.ThumbnailUrl,
              FileName: f.FileName,
              PreviewUrl: f.Url
            } as ArtworkFile
          }
        )

        model.decorationMethod.virtualDesignImage =
          item.VirtualDesignImage !== null ? item.VirtualDesignImage : undefined

        model.decorationMethod.isVirtualDesign = item.IsVirtualDesign
        // model.decorationMethod.virtualDesignImage =
        //   item.VirtualDesignImage === null
        //     ? undefined
        //     : item.VirtualDesignImage;

        model.decorationMethod.virtualDesignArts.push(...item.VirtualDesignArts)
        model.decorationMethod.virtualDesignFonts.push(...item.VirtualDesignFonts)
        if (item.VirtualDesignLogo !== null) {
          model.decorationMethod.virtualDesignLogo.push(
            ...item.VirtualDesignLogo
          )
        }
        model.decorationMethod.virtualDesignJson = item.VirtualDesignJson

        //       model.decorationMethod.virtualDesignFonts.push(
        //         ...item.VirtualDesignFonts.map(f=>{
        //           return {
        //             ColorName: f.;
        // Fill: string;
        // FontFamily: string;
        // Text: string;
        //           }
        //         })
        //       );

        imprintMethodState.add(model)
      }
    }
  })

  imprintMethodState.checkSameColor();
  if (dropShipSetting) {
    if (soInfo.DropShipValue) {
      const sList = soInfo.DropShipValue.split('_|_')

      dropShipState.setDropship({
        needDropShip: true,
        locationNum: parseInt(sList[1]),
        needAddMore: sList[2] === '1',
        addlProductionTime: dropShipSetting.AddlProductionTime
      })
    } else {
      dropShipState.setDropship({
        needAddMore: false,
        needDropShip: false,
        locationNum: 0,
        addlProductionTime: dropShipSetting.AddlProductionTime
      })
    }
  }

  // 设置production time
  // ProductionTime


}
